import axios from "axios";
import {isDevEnv} from '@/components/utils/utils';
import {ENVIRONMENT} from "@/consts/consts";

const BRAINPOWER_API = process.env.VUE_APP_API;


// console.debug({NODE_ENV : process.env.NODE_ENV})
const OUTBRAIN_ROOT_API =  isDevEnv() || ENVIRONMENT.isSimulator || ENVIRONMENT.isLocal ? "https://www2.outbrain.com" :  "/"

console.log('isSimulator', ENVIRONMENT.isSimulator)
console.log('isDevEnv', isDevEnv())
export const brainpowerClient = axios.create({
  baseURL : BRAINPOWER_API
});


export const outbrainClient = axios.create({
  baseURL : OUTBRAIN_ROOT_API
});


